<template>
  <div class="myinfo">
    <div class="text-center">
      <img src="../../../assets/images/s1.png"  v-show="x==1"/>
      <img src="../../../assets/images/s2.png"  v-show="x==2" />
      <img src="../../../assets/images/s3.png" v-show="x==3" />
    </div>
    <div class="result">
      <ul>
        <li>
          <span>论文审核结果：</span>失败
        </li>
        <li>
          <span>审核原因：</span>提交论文格式不对，不予通过
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangeStateFifth',
  data: function () {
    return {
      x: 2
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/mixins.styl'
  .myinfo{
    background:#fff;
    padding:28px;
    margin-top:20px;
  }
  .result{
    width:80%;
    margin:0 auto;
    li{
      line-height:24px;
      margin-bottom:20px;
      span{
        font-weight:bold;
        color:#999;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/graduationmanagement/components/ChangeStateFifth.vue